import { jsx as i, jsxs as f } from "react/jsx-runtime";
import p from "./index.es873.js";
import { ConfirmationDialogBoxIllustration as c } from "./index.es874.js";
import { ConfirmationDialogBoxContent as x } from "./index.es875.js";
import { ConfirmationDialogBoxActions as D } from "./index.es876.js";
import { BaseModal as d } from "./index.es872.js";
const g = "confirmation-dialog", I = ({
  actions: r,
  testId: o = g,
  title: t,
  content: n,
  illustration: a,
  actionsOrientation: m = "horizontal",
  additionalLink: l,
  hasBackdrop: s = !0,
  ...e
}) => /* @__PURE__ */ i(d, { ...e, size: "small", testId: o, hasBackdrop: s, children: /* @__PURE__ */ f("div", { className: p.confirmationDialogWrapper, "data-testid": o + "-wrapper", children: [
  /* @__PURE__ */ i(
    c,
    {
      illustration: a,
      testId: o + "-illustration"
    }
  ),
  /* @__PURE__ */ i(
    x,
    {
      title: t,
      content: n,
      testId: o + "-content",
      additionalLink: l
    }
  ),
  /* @__PURE__ */ i(
    D,
    {
      testId: o + "-actions",
      actionsOrientation: m,
      actions: r
    }
  )
] }) });
export {
  g as CONFORMATION_DIALOG_BOX_TESTID,
  I as ConfirmationDialogBox
};
//# sourceMappingURL=index.es96.js.map
